import React from 'react';
import { Outlet } from 'react-router-dom';

const AppEmptyLayout: React.FC = () => {
  return <Outlet />;
};

export default AppEmptyLayout;
